import { doc, onSnapshot, serverTimestamp, setDoc, type Unsubscribe } from 'firebase/firestore';
import { db } from './firebase';
import type { PurchaseOverheadGroup } from '../types/purchasing';
import {
  budgetedMonthlyEquivalent,
  emptyOpexBudgets,
  isOpexBudgetInterval,
  parseOpexBudgets,
  type OpexBudgetInterval,
} from './opexBudgetMath';

export const OPEX_BUDGETS_DOC_ID = 'opexBudgets';

export {
  OPEX_BUDGET_INTERVALS,
  budgetedMonthlyByGroup,
  budgetedMonthlyEquivalent,
  emptyOpexBudgets,
  formatOpexBudgetAmount,
  groupBudgetEnvelope,
  groupBudgetedMonthly,
  isOpexBudgetInterval,
  opexBudgetIntervalMeta,
  parseOpexBudgets,
  parseOpexGroupBudget,
  totalBudgetedOpexMonthly,
} from './opexBudgetMath';
export type { OpexBudgetInterval, OpexBudgets, OpexGroupBudget } from './opexBudgetMath';

export function subscribeOpexBudgets(
  onSettings: (budgets: ReturnType<typeof emptyOpexBudgets>) => void,
  onError?: (err: unknown) => void,
): Unsubscribe {
  return onSnapshot(
    doc(db, 'financeSettings', OPEX_BUDGETS_DOC_ID),
    snap => onSettings(parseOpexBudgets(snap.data())),
    err => {
      console.warn('[opexBudgets] listen failed — using empty envelopes', err);
      onSettings(emptyOpexBudgets());
      onError?.(err);
    },
  );
}

export async function saveOpexGroupBudget(
  group: PurchaseOverheadGroup,
  next: { amountUsd: number | null; interval: OpexBudgetInterval },
  by: { userId: string },
): Promise<void> {
  const interval = isOpexBudgetInterval(next.interval) ? next.interval : 'monthly';
  const amountUsd = next.amountUsd == null || !Number.isFinite(next.amountUsd) ? null : next.amountUsd;
  const monthlyUsd = budgetedMonthlyEquivalent({ amountUsd, interval });
  await setDoc(
    doc(db, 'financeSettings', OPEX_BUDGETS_DOC_ID),
    {
      groups: {
        [group]: { amountUsd, interval, monthlyUsd },
      },
      updatedAt: serverTimestamp(),
      updatedBy: by.userId,
    },
    { merge: true },
  );
}
